import { Typography } from '@/components';
import { FormFieldContainer, FormSubmitButton, FormWrapper } from '@/components/Form/Form.styles';
import ErrorMessage from '@/components/FormField/components/ErrorMessage';
import { TextInput, TextInputWrapper } from '@/components/FormField/components/FormFieldType/Input/Input.styles';
import Label from '@/components/FormField/components/Label';
import { LoginButtonWrapper } from '@/components/SsoLoginButton/SsoLoginButton.styles';
import { styledText } from '@/components/Typography/Typography.styles';
import { TextStyles } from '@/constants';
import { DividedLine, DividedText, DividerWrapper } from '@/modules/pmt/components/Divider/Divider.style';
import styled, { css } from 'styled-components';

const clampText = `
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
`;

export const PopupContentWrapper = styled.div<{ isExpanded: boolean }>(({ theme, isExpanded }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  overflow: 'auto',
  background: theme.colors.darkBlue,
  wordBreak: 'break-word',
  padding: theme.spacing[isExpanded ? 32 : 40],
  paddingLeft: theme.spacing[isExpanded ? 20 : 16],

  [`${theme.mediaBreakpointUp.lg}`]: {
    paddingTop: theme.spacing[isExpanded ? 20 : 16],
    paddingBottom: theme.spacing[isExpanded ? 20 : 16],
  },

  [LoginButtonWrapper]: {
    width: '100%',
  },

  [TextInputWrapper]: {
    marginTop: 0,
    borderColor: theme.colors.inactiveWhite,

    [Label]: {
      background: theme.colors.darkBlue,
      color: theme.colors.inactiveWhite,
    },
  },

  [TextInput]: {
    color: theme.colors.highEmphasisWhite,
  },

  [FormFieldContainer]: {
    margin: 0,
  },

  [FormSubmitButton]: {
    marginTop: theme.spacing[8],
  },

  [ErrorMessage]: {
    marginBottom: 0,
  },

  [DividerWrapper]: {
    marginTop: theme.spacing[16],
    marginBottom: theme.spacing[8],
  },

  [DividedText]: {
    color: theme.colors.mediumEmphasisWhite,
    backgroundColor: theme.colors.darkBlue,
  },

  [DividedLine]: {
    backgroundColor: theme.colors.pressedWhite,
  },

  [FormWrapper]: {
    backgroundColor: 'transparent',
  },
}));

export const Title = styled(Typography).attrs({
  variant: TextStyles['Heading 2'],
})<{ isExpanded: boolean }>`
  ${clampText}
  -webkit-line-clamp: 2;
  color: ${({ theme }) => theme.colors.highEmphasisWhite};
  margin-bottom: ${({ theme }) => theme.spacing[12]};

  ${({ isExpanded }) =>
    !isExpanded &&
    css`
      margin: 0;
      ${styledText[TextStyles['Heading 3']]}
    `}
`;
